import { render, staticRenderFns } from "./FixSmsSafetyBriefings.vue?vue&type=template&id=47c30e86&scoped=true"
import script from "./FixSmsSafetyBriefings.vue?vue&type=script&lang=js"
export * from "./FixSmsSafetyBriefings.vue?vue&type=script&lang=js"
import style0 from "./FixSmsSafetyBriefings.vue?vue&type=style&index=0&id=47c30e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c30e86",
  null
  
)

export default component.exports